import '../sass/media-and-accordion.scss';

(() => {
    const swiperScript = document.querySelector('#blenheim-schools-swiper-js');
    const detailsScript = document.querySelector('#blenheim-schools-details-js');
    const $blocks = document.querySelectorAll('.block.media-and-accordion');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $mediaCarousel = $block.querySelector('.media-and-accordion__media-carousel');
        const $accordions = $block.querySelectorAll('.media-and-accordion__accordion');

        let mediaCarousel, accordions = [];

        const initDetails = () => {
            if ($accordions) {
                $accordions.forEach(($accordion, index) => {
                    const accordion = new Details($accordion, {
                        allowClose: false
                    });

                    accordions.push(accordion);

                    $accordion.addEventListener('detailsopen', () => {
                        const closedAccordions = accordions.filter((accordion, closeAccordionIndex) => closeAccordionIndex !== index);

                        closedAccordions.forEach(accordion => {
                            accordion.close();
                        });

                        mediaCarousel?.slideTo(index);
                    });
                });
            }
        };

        const initCarousel = () => {
            if ($mediaCarousel) {
                mediaCarousel = new Swiper($mediaCarousel, {
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true,
                    },
                    allowTouchMove: false,
                });
            }
        };

        if (typeof Swiper !== 'undefined') {
            initCarousel();
        } else if (swiperScript) {
            swiperScript.addEventListener('load', () => {
                initCarousel();
            });
        } else {
            window.addEventListener('load', () => {
                const swiperScript = document.querySelector('#blenheim-schools-swiper-js');

                if (!swiperScript) return;

                initCarousel();
            });
        }

        if (typeof Details !== 'undefined') {
            initDetails();
        } else if (detailsScript) {
            detailsScript.addEventListener('load', () => {
                initDetails();
            });
        } else {
            window.addEventListener('load', () => {
                const detailsScript = document.querySelector('#blenheim-schools-swiper-js');

                if (!detailsScript) return;

                initDetails();
            });
        }
    });
})();
